import { render, staticRenderFns } from "./CompleteReg.vue?vue&type=template&id=6e3a00e3"
import script from "./CompleteReg.vue?vue&type=script&lang=js"
export * from "./CompleteReg.vue?vue&type=script&lang=js"
import style0 from "./CompleteReg.vue?vue&type=style&index=0&id=6e3a00e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports